import application from 'application/application';

import template from './otherwise.template.html';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.otherwise', {
				views: {
					'default@root.default': {
						templateUrl: template
					}
				},
				data: {
					documentTitle: 'Página não encontrada'
				}
			});

	}]);
